import { useEffect, useRef } from "react";
import { useSettings } from "../context/SettingsContext";

/**
 * Włącza nowy modal maili w zależności od settinga
 */
export const useEmailMessageModal = () => {
  const isEnabled = useRef(false);
  const { settings } = useSettings();

  const newLookEmailMessageSettingValue =
    settings?.newLookEmailMessage ?? false;

  useEffect(
    function enableEmailMessageDialog() {
      if (newLookEmailMessageSettingValue && isEnabled.current === false) {
        isEnabled.current = true;

        const importEmailAuraCompat = async () => {
          await import("../pages/email-message/auraCompat");
        };

        importEmailAuraCompat();
      }
    },
    [newLookEmailMessageSettingValue]
  );
};
